/**
 * VUEX的模块定义的页面，加入新的模块都需要在这里引入
 *
 * Vuex中state内部结构的设计，请参考redux文档中提到的【State 范式化】
 * http://cn.redux.js.org/docs/recipes/reducers/NormalizingStateShape.html
 * */

import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import common from '@src/store/modules/common';
import app from '@src/store/modules/app';
import * as System from '@src/utils/system';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common,
        app,
    },
    plugins: System.isDebug ? [createLogger()] : [],
    strict: System.isDebug // 严格模式很耗性能，生产环境禁止开启
});



// WEBPACK FOOTER //
// ./src/store/index.js